import React from 'react';
import Navbar from './Components/Navbar/Navbar'; // Navbar component
import Footer from './Components/Footer/Footer'; // Footer component
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // For routing
import Home from './pages/Home/Home'
import About from './pages/About/About'
import AiDaptiv from './pages/aidaptiv/aidaptiv'
import FAQS from './pages/Faqs/Faqs';
import Contact from './pages/Contact/Contact';

import Solutions from './pages/Solutions/Solutions';
import Appliances from './pages/Appliances/Appliances';
import TermsPage from './pages/TermsAndConditions/TermsAndConditions';
import PolicyPage from './pages/PrivacyAndPolicy/PrivacyAndPolicy'
import Careers from './pages/Careers/Careers'
function App() {
  return (
    <Router>
     <Navbar/>
        
        <Routes>
          <Route path="/" element={<Home />} />       
          <Route path="/about" element={<About />} />
          <Route path="/faqs" element={<FAQS />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/solutions" element={<Solutions/>}/>
          <Route path="/appliances" element={<Appliances/>}/>
          <Route path="/aiDAPTIV+" element={<AiDaptiv/>}/>
          {/* <Route path="/careers" element={<Careers/>}/> */}
          <Route path="/termsandconditions" element={<TermsPage/>}/>
          <Route path="/privacyandpolicy" element={<PolicyPage/>}/>
          {/* Add other routes as necessary */}
        </Routes>

      <Footer/>
      
    </Router>
  );
}

export default App;
